var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneboardFinanceImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 958.79 919.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#407bff;}.cls-19,.cls-2,.cls-5{fill:#fff;}.cls-2{isolation:isolate;opacity:0.9;}.cls-10,.cls-3,.cls-4,.cls-5,.cls-9{opacity:0.2;}.cls-6{opacity:0.1;}.cls-10,.cls-20,.cls-7{fill:#fafafa;}.cls-21,.cls-7{opacity:0.5;}.cls-11,.cls-12,.cls-16,.cls-17,.cls-8,.cls-9{fill:none;}.cls-8{stroke:#407bff;stroke-miterlimit:10;}.cls-9{stroke:#000;stroke-width:2px;}.cls-11,.cls-12,.cls-16,.cls-17,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-12{stroke:#fafafa;}.cls-12{stroke-dasharray:5.04 5.04;}.cls-13{fill:#b97964;}.cls-14{fill:#263238;}.cls-15{fill:#a24e3f;}.cls-16,.cls-17{stroke:#222221;}.cls-16{stroke-width:0.75px;}.cls-18{fill:#222221;}.cls-19{opacity:0.4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0424\\u0438\\u043D\\u0430\\u043D\\u0441\\u044B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.7,385.48C510,317.84,797.85,11.57,925.85,255.88,1033,460.31,796.06,652.08,654.23,722.24c-184.5,91.3-455.68,55.25-601.66-117.33C-10.21,530.59-32.86,425.53,76.66,406c37-6.61,99.67,17.48,141.44,15.38C271.63,418.67,324.06,408.11,370.7,385.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.7,385.48C510,317.84,797.85,11.57,925.85,255.88,1033,460.31,796.06,652.08,654.23,722.24c-184.5,91.3-455.68,55.25-601.66-117.33C-10.21,530.59-32.86,425.53,76.66,406c37-6.61,99.67,17.48,141.44,15.38C271.63,418.67,324.06,408.11,370.7,385.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Coin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M449.14,241.51c-5.68,13.75-39,12.83-73.95-1.59s-58.67-37.24-53-51c1.31-3.19,5-15.1,8.91-16.75,13-5.49,37.78,6.87,64.63,17.94,25,10.31,53.53,16.93,58,30.51C456.4,228.86,450.75,237.59,449.14,241.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M453.72,220.62c2.12,10.8-2.56,16-4.59,20.88-2.09,5.08-7.93,8.15-16.21,9.29-1,.16-2.05.26-3.12.34a85.47,85.47,0,0,1-19-1c-.9-.11-1.79-.28-2.7-.44a149.66,149.66,0,0,1-21.75-5.59c-.82-.27-1.64-.57-2.46-.87-2.87-1-5.79-2.1-8.69-3.31s-5.7-2.45-8.45-3.76c-.79-.36-1.57-.76-2.34-1.13a149.06,149.06,0,0,1-18.63-10.92c-.73-.49-1.4-1-2.1-1.47A85.24,85.24,0,0,1,329.48,210c-.64-.71-1.22-1.41-1.77-2.12-5.52-7-7.69-13.64-5.51-18.93,1.42-3.43,4.51-15.09,8.9-16.76s10-1.42,16.59,0c.84.19,1.72.39,2.6.61,12.93,3.27,28.95,10.57,45.43,17.38,19.44,8,42.43,16.33,53.68,26,.7.58,1.33,1.18,1.94,1.79A24.59,24.59,0,0,1,453.72,220.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.48,170.61l-1.19,2.14L329.48,210c-.64-.71-1.22-1.41-1.77-2.12l20-35.72,1.55-2.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.21,185.77l-21.44,38.35c-.73-.49-1.4-1-2.1-1.47L365,184.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.64,207.8l-20.3,36.31c-.82-.27-1.64-.57-2.46-.87l20.52-36.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.31,197.56l-21.57,38.61c-.79-.36-1.57-.76-2.34-1.13l21.67-38.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.55,214.82l-19.76,35.32c-.9-.11-1.79-.28-2.7-.44l20.22-36.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.56,229.41c-5.67,13.75-38.59,13.22-73.54-1.2s-58.67-37.24-53-51,38.59-13.22,73.54,1.2S459.24,215.66,453.56,229.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M441.68,224.51c-4,9.72-29.67,8.35-57.32-3.06s-46.82-28.53-42.81-38.24,29.67-8.35,57.32,3.06S445.69,214.8,441.68,224.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.74,117.13c9.11,11.76-8.27,40.21-38.15,63.36s-61.5,32.37-70.6,20.61c-2.11-2.73-10.62-11.83-10.1-16.06,1.71-14,24.76-29.36,47.71-47.14,21.37-16.55,41.32-38,55.3-35.12C618.38,104.54,623.15,113.78,625.74,117.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M609.9,102.77c10.42,3.53,12.58,10.15,15.84,14.36s3.12,10.93,0,18.69c-.36.94-.79,1.9-1.26,2.88a85.5,85.5,0,0,1-10.31,16c-.54.72-1.13,1.41-1.72,2.13a150.7,150.7,0,0,1-15.68,16.08c-.64.57-1.31,1.14-2,1.71-2.3,2-4.7,4-7.19,5.89s-5,3.73-7.47,5.46c-.71.5-1.44,1-2.14,1.46a148.14,148.14,0,0,1-18.75,10.74c-.78.38-1.56.72-2.32,1.08a84.34,84.34,0,0,1-18,6c-.93.2-1.82.36-2.71.49-8.81,1.31-15.66-.12-19.17-4.64-2.27-2.93-10.84-11.42-10.11-16s3.76-9.43,8.23-14.42c.58-.63,1.18-1.29,1.82-1.95,9.27-9.59,23.57-19.85,37.67-30.77,16.63-12.87,35.27-28.68,49.21-33.66a25.9,25.9,0,0,1,2.52-.78A22.45,22.45,0,0,1,609.9,102.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.66,166.59l1.27,2.09,21.94,36.57c-.93.2-1.82.36-2.71.49l-21-35.11-1.64-2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.64,160.48l22.6,37.68c-.78.38-1.56.72-2.32,1.08l-22.49-37.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.36,137.23l21.4,35.67c-.64.57-1.31,1.14-2,1.71l-21.64-36.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.36,148,580.13,186c-.71.5-1.44,1-2.14,1.46l-22.84-38.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.35,120l20.81,34.71c-.54.72-1.13,1.41-1.72,2.13L591.13,121.3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 563.34,
    cy: 149.18,
    rx: 68.44,
    ry: 26.93,
    transform: "translate(26.61 376.17) rotate(-37.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 564.47,
    cy: 148.31,
    rx: 54.16,
    ry: 19.03,
    transform: "translate(27.38 376.68) rotate(-37.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502,62c-3,16.86-40.72,24-83.57,16.39S343.3,50.94,346.3,34.07c.7-3.91,1.9-18.2,5.91-21,13.3-9.38,44.2-1.55,77.12,4.31C460,22.8,493.72,23.23,502,37.41,507.09,46,502.89,57.22,502,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.06,37.41C507.09,49,503.11,56,502,62c-1.1,6.23-6.92,11.12-16,14.43-1.08.43-2.23.8-3.43,1.16A98.19,98.19,0,0,1,461,81.17c-1,.09-2.08.12-3.15.17a174.39,174.39,0,0,1-25.84-1c-1-.11-2-.24-3-.37-3.47-.43-7-.94-10.58-1.59s-7-1.35-10.44-2.16c-1-.21-1.94-.46-2.9-.69a171.83,171.83,0,0,1-23.65-7.71c-.94-.37-1.82-.77-2.72-1.14A97.86,97.86,0,0,1,359.67,56c-.89-.65-1.71-1.29-2.51-1.95-7.93-6.51-12-13.45-10.85-19.94.75-4.21,1.36-18.08,5.89-21S363.15,9,370.86,8.92c1,0,2,0,3.07.05,15.35.5,35.17,4.78,55.39,8.38,23.84,4.24,51.74,8,66.76,16a30.13,30.13,0,0,1,2.62,1.55A25.77,25.77,0,0,1,502.06,37.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.74,6.27,373.93,9,359.67,56c-.89-.65-1.71-1.29-2.51-1.95l13.7-45.1,1.06-3.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.17,19.46l-14.7,48.41c-.94-.37-1.82-.77-2.72-1.14l14.61-48.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.94,34.55,432,80.39c-1-.11-2-.24-3-.37l14.07-46.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.8,27.54,408,76.27c-1-.21-1.94-.46-2.9-.69L420,26.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.57,36.57,461,81.17c-1,.09-2.08.12-3.15.17L471.73,35.7Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 426.45,
    cy: 33.52,
    rx: 31.02,
    ry: 78.81,
    transform: "translate(318.72 447.5) rotate(-79.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 428.07,
    cy: 33.81,
    rx: 21.91,
    ry: 62.37,
    transform: "translate(319.77 449.33) rotate(-79.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M725.75,492.49l-263.7,15.34A77.08,77.08,0,0,0,435,514.44L148.55,642.65a24,24,0,0,0-13.82,26.81l47.39,223.81c3.25,15.35,20.37,23.44,34.6,16.33L499.43,768.47l261.05-8.83a22.63,22.63,0,0,0,21.77-26.08L747.31,519.24C745.51,508.17,737.11,492.15,725.75,492.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M725.75,492.49l-263.7,15.34A77.08,77.08,0,0,0,435,514.44L148.55,642.65a24,24,0,0,0-13.82,26.81l47.39,223.81c3.25,15.35,20.37,23.44,34.6,16.33L499.43,768.47l261.05-8.83a22.63,22.63,0,0,0,21.77-26.08L747.31,519.24C745.51,508.17,737.11,492.15,725.75,492.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.29,
    y: 362.06,
    width: 188.21,
    height: 366.39,
    transform: "translate(-303 314.72) rotate(-42.67)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "444.75 616.19 306.36 743.74 58.05 474.34 148.86 390.63 196.44 346.77 204.37 355.37 444.75 616.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 169.38,
    y: 374.16,
    width: 166.08,
    height: 342.74,
    transform: "translate(-302.92 315.48) rotate(-42.67)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 250.58,
    cy: 543.53,
    rx: 34.48,
    ry: 43.24,
    transform: "matrix(0.74, -0.68, 0.68, 0.74, -302.05, 313.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "304.88 634.41 255.71 651.4 148.86 390.63 196.44 346.77 204.37 355.37 304.88 634.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 194.31,
    y: 262.33,
    width: 188.21,
    height: 366.39,
    transform: "translate(-134.58 124.98) rotate(-19.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 194.31,
    y: 262.33,
    width: 188.21,
    height: 366.39,
    transform: "translate(-134.58 124.98) rotate(-19.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 206.21,
    y: 274.8,
    width: 166.08,
    height: 342.73,
    transform: "translate(-134.75 125.3) rotate(-19.93)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 288.33,
    cy: 443.62,
    rx: 34.48,
    ry: 43.24,
    transform: "translate(-133.94 124.84) rotate(-19.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.47,501.58,467.38,516.24a75.18,75.18,0,0,0-26.69,6.53L158.47,650.19a23.9,23.9,0,0,0-13.56,26.75l47.32,223.82a23.93,23.93,0,0,0,34.18,16.42L504.93,776.84l257.49-8.14a22.41,22.41,0,0,0,21.41-26l-35-214.31C747,517.31,738.68,501.28,727.47,501.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 477.96,
    y1: 555.46,
    x2: 701.11,
    y2: 541.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 451.23,
    y1: 561.22,
    x2: 492,
    y2: 748.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M179.41,730.28l28.75,144.05S230.2,817.17,179.41,730.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M183.18,732c1,2.62,255.36-106.59,255.36-106.59S445,703.9,368.43,746.83,183.18,732,183.18,732Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 352.15,
    cy: 725.2,
    r: 11.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M438.67,625.39s31.55,47.46,23.92,128.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 167.24,
    y1: 673.71,
    x2: 169.53,
    y2: 672.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 174.14,
    y1: 670.66,
    x2: 430.17,
    y2: 557.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 432.48,
    y1: 556.47,
    x2: 434.77,
    y2: 555.46
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 485.44,
    y1: 597.55,
    x2: 708.6,
    y2: 583.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 495.49,
    y1: 650.05,
    x2: 718.64,
    y2: 636.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M669.74,277.06s-5.62,59.79-27.83,64.94-41-4.09-41-4.09L582.87,324l-8.81,30.71s9.63,13.1,29.74,4c0,0,35.85,15.8,55.7,0s26.2-59.08,26.2-59.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M687.6,248.1s-15.5-26.41-8.46-74.32,47.2-53.88,62.7-50.36,28.18,18.36,38.74,46.69,14.44,35.73,32,30.79,64.46-20.42,77.49-6.69,8.81,29.24,8.81,29.24,65.15-15.85,59.52,42.26-99.68,112.36-189.14,55S687.6,248.1,687.6,248.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M686.87,388.76s-17.71,152.29-17.12,223.72,26,239.65,26,239.65H727s-4.13-134.58-3.54-180.63,8.85-122.19,8.85-122.19,10,68.48,21.84,92.68,77.33,109.79,122.78,136.36l21.25-19.48S851,700.43,833.26,671.5s-33.64-37.18-40.14-90.9S797.84,440.7,779,388.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M732.32,549.31l-13.6-96.52s-10.74,58,10.42,128.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "702.14 860.71 703.19 890.62 724.18 892.37 725.23 889.57 725.23 858.62 702.14 860.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "692.17 849.35 694.1 860.54 730.12 861.41 732.4 847.95 692.17 849.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "867.06 780.44 900.46 749.31 907.81 761.03 879.13 787.26 867.06 780.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "883.15 780.44 905.18 798.98 919.35 782.36 901.25 763.65 883.15 780.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M923.62,781.07,937,789.28a4.89,4.89,0,0,1,1.1,7.41c-9.68,10.9-34.35,38.63-36.8,40.59-3.06,2.45-6.73-1.75-7.61-5.6,0,0,7-9.27,7.61-15.21a106.9,106.9,0,0,0,.09-13.8,4.54,4.54,0,0,1,1.09-3.15l14.9-17.46A4.88,4.88,0,0,1,923.62,781.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M729.3,893.14l2.77,15.4a4.89,4.89,0,0,1-4.79,5.77c-14.57.06-51.68.17-54.78-.35-3.87-.65-3.19-6.18-.91-9.4,0,0,11.57-1,16.41-4.48A106.86,106.86,0,0,0,698.34,891a4.56,4.56,0,0,1,3.08-1.3l22.94-.54A4.89,4.89,0,0,1,729.3,893.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.31,304.31l32-22.45s-8.5-34-21.09-35.72-75.19-13.61-115,0c0,0-14.29,4.08-18.71,44.22l17,5.45s6.12,75.18,9.86,86.75h90.84S778.23,317.92,782.31,304.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M789.22,299.46s12.11,34.6,14.27,53.19c0,0-28.81-11.46-36.25-16.73l-5.61-20.24-19.17-9.19-5.57,15.18,15.79,19.83s43.37,40.58,65.37,31.29-8.7-87.46-8.7-87.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M707.85,148s-11.08,22.15-10.15,40.15,9.92,25.38,27.23,27.92c0,0,7.38,23.08-12,25.38-1.48.18-2,6.06-1.88,7,.5,3.75,4.21,5.79,7.57,6.66a50.51,50.51,0,0,0,11.11,1.23c8.29.27,15.13-3.08,20.66-9.2.43-.47,4.31-5.45,4.3-5.46s-9.23-4.58-6-34.61a25,25,0,0,0,9.7-12s6-3,7.38-9-3.92-14.3-13.61-6c0,0-18.23-9.23-25.16-41.53A32.46,32.46,0,0,1,707.85,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M713.06,183.24l1.58-11.85-8.4,9.28A8.35,8.35,0,0,0,713.06,183.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M717.93,191.9s8.85,1.36,13.09-4.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M726.78,154.81s5.63-2.18,11.45,3.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M711.48,152.24s-5-.8-7.41,2.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M730.34,170.39c-.23,1.78-1.39,3.11-2.57,3s-2-1.72-1.73-3.51,1.38-3.11,2.57-3S730.57,168.61,730.34,170.39Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 707.77,
    cy: 166.19,
    rx: 3.26,
    ry: 2.17,
    transform: "translate(451.76 846.65) rotate(-82.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M728.61,166.88l-4.05-1.76S725.4,168.76,728.61,166.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M708.53,163.09l-4-1.76S705.32,165,708.53,163.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "683.22 378.56 683.22 389.24 781.6 390.08 778.97 377.35 683.22 378.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "683.22 378.56 683.22 389.24 781.6 390.08 778.97 377.35 683.22 378.56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Target"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M684.41,326.69,630.31,515a32.8,32.8,0,0,1-28.25,23.61,33.27,33.27,0,0,1-12.34-1.13L486.18,507.67a32.83,32.83,0,0,1-22.48-40.59L517.82,278.8a32.82,32.82,0,0,1,40.6-22.46L662,286.07A32.83,32.83,0,0,1,684.41,326.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M684.41,326.69,630.31,515a32.8,32.8,0,0,1-28.25,23.61,33.27,33.27,0,0,1-12.34-1.13L486.18,507.67a32.83,32.83,0,0,1-22.48-40.59L517.82,278.8a32.82,32.82,0,0,1,40.6-22.46L662,286.07A32.83,32.83,0,0,1,684.41,326.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.41,328.93l-54.1,188.26a32.78,32.78,0,0,1-19.25,21.37,33.27,33.27,0,0,1-12.34-1.13L486.18,507.67a32.83,32.83,0,0,1-22.48-40.59L517.82,278.8a32.75,32.75,0,0,1,19.25-21.35,33.27,33.27,0,0,1,12.34,1.13L653,288.31A32.83,32.83,0,0,1,675.41,328.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M675.41,328.93l-54.1,188.26a32.78,32.78,0,0,1-19.25,21.37,33.27,33.27,0,0,1-12.34-1.13L486.18,507.67a32.83,32.83,0,0,1-22.48-40.59L517.82,278.8a32.75,32.75,0,0,1,19.25-21.35,33.27,33.27,0,0,1,12.34,1.13L653,288.31A32.83,32.83,0,0,1,675.41,328.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 498.73,
    y: 340.59,
    width: 11.51,
    height: 146.92,
    transform: "translate(131.21 -121.31) rotate(15.74)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "505.96 490.84 494.89 487.66 534.73 346.28 545.79 349.46 505.96 490.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "522.06 495.47 510.99 492.29 550.83 350.9 561.89 354.08 522.06 495.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 595.18,
    y: 368.3,
    width: 11.51,
    height: 146.92,
    transform: "translate(142.34 -146.43) rotate(15.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M624.94,332.65l-5.51,19.19L612.87,350a12.46,12.46,0,0,1-8.61-15.34l3.59-12.74,13.25,3.79A5.63,5.63,0,0,1,624.94,332.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M621.79,323.24l-13.25-3.79,4-14a12.46,12.46,0,0,1,15.35-8.61l6.82,1.92-5.95,20.68A5.56,5.56,0,0,1,621.79,323.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M634.34,329.52l13.33,3.82-3.54,12.53a12.4,12.4,0,0,1-15.32,8.61l-6.92-2,5.51-19.17A5.61,5.61,0,0,1,634.34,329.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M652.38,316.63l-4,14.25L635,327.06a5.63,5.63,0,0,1-3.85-6.94l5.95-20.68,6.63,1.87A12.42,12.42,0,0,1,652.38,316.63Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneboardFinanceImage);
export default __webpack_public_path__ + "static/media/oneboardFinanceImage.5518bc0c4401fc47b6bdd94e103eca68.svg";
export { ForwardRef as ReactComponent };